import { apiNWL, apiController, restartApiCotroller } from '@/utils/nwlApi';
import store from '@/redux/store';
import { setShowLoader } from '@/redux/slices/loaderSlice';

const getImpactedForecast = async (orgId, locId, dtId, simId) => {
	try {
		restartApiCotroller();

		store.dispatch(setShowLoader(false));
		const response = await apiNWL.get(
			`/organisations/${orgId}/locations/${locId}/forecasts/impacted?dtId=${dtId}&simId=${simId}&primary=true`,
			{
				signal: apiController.signal,
			},
		);
		return response.data || {};
	} catch (error) {
		console.error(error);
	}
};

const getImpactedForecastTimeline = async (orgId, locId, dtId, simId) => {
	try {
		restartApiCotroller();

		store.dispatch(setShowLoader(false));
		const response = await apiNWL.get(
			`/organisations/${orgId}/locations/${locId}/forecasts/impacted/timeline?dtId=${dtId}&simId=${simId}&primary=true`,
			{
				signal: apiController.signal,
			},
		);
		return response.data || {};
	} catch (error) {
		console.error(error);
	}
};

export { getImpactedForecast, getImpactedForecastTimeline };
